import { render, staticRenderFns } from "./rewards.vue?vue&type=template&id=eff892c0&scoped=true&"
import script from "./rewards.vue?vue&type=script&lang=js&"
export * from "./rewards.vue?vue&type=script&lang=js&"
import style0 from "./rewards.vue?vue&type=style&index=0&id=eff892c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff892c0",
  null
  
)

export default component.exports